<template>
  <!-- 底部组件 -->
  <div>
    <!-- 底部 -->
    <div class="top12" :style="{ backgroundImage: `url(${infoList?.bottom_banner?.image})` }">
      <div class="top12-center">
        <div class="top12-title">{{ infoList?.bottom_banner?.title }}</div>
        <div class="top12-btn" @click="goView(infoList?.set?.kefu_url)">立即咨询</div>
      </div>
    </div>
    <div class="bottomBar">
      <div class="bottomBar-center">
        <div class="bottomBar-left">
          <div class="left-title">{{ infoList?.set?.site_name }}</div>
          <div class="left-title1">联系电话：</div>
          <div class="left-title2">{{ infoList?.set?.site_phone }}</div>
          <div class="left-title3">公司地址：</div>
          <div class="left-title4">{{ infoList?.set?.site_address }}</div>
        </div>
        <div class="bottomBar-right">
          <div class="right-menu1">
            <div class="menu1">首页</div>
            <div class="menu">平台优势</div>
            <div class="menu">主要业务</div>
            <div class="menu">小二兼职</div>
            <div class="menu">悦客联盟</div>
            <div class="menu">项目保</div>
            <div class="menu">软件定制</div>
          </div>
          <div class="right-menu2">
            <div class="menu1">关于我们</div>
            <div class="menu">公司简介</div>
            <div class="menu">平台公告</div>
          </div>
          <div class="right-menu3">
            <div class="menu1">联系我们</div>
            <div class="menu">联系方式</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { homeInfo } from "@/api/home.js"
import { onMounted, ref } from "vue"

const infoList = ref<any>({})

infoList.value = JSON.parse(localStorage.getItem("info"))


const goView = (url: any) => {
  window.open(url)
}

onMounted(() => {
})
</script>

<style lang="scss" scoped>
.top12 {
  height: 163px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .top12-center {
    width: 642px;
    height: 49px;
    // background: red;
    display: flex;
    align-items: center;

    .top12-title {
      font-weight: 400;
      font-size: 34px;
      color: #ffffff;
      white-space: nowrap;
    }

    .top12-btn {
      width: 140px;
      height: 49px;
      background: #ff6b10;
      border-radius: 12px;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 48px;
      cursor: pointer;
    }

    .top12-btn:hover {
      background: linear-gradient(135deg, #FFAA32 0%, #FF690D 100%);
    }
  }
}

.bottomBar {
  height: 420px;
  width: 100%;
  background: #222629;
  display: flex;
  align-items: center;
  justify-content: center;

  .bottomBar-center {
    width: 1200px;
    height: calc(420px - 158px);
    // background: red;
    display: flex;
    justify-content: space-between;

    .bottomBar-left {
      width: 310px;
      height: 100%;

      //   background: blue;
      .left-title {
        font-weight: 600;
        font-size: 42px;
        color: #ffffff;
        white-space: nowrap;
      }

      .left-title1 {
        font-weight: 400;
        font-size: 16px;
        color: #aaaaaa;
        margin-top: 22px;
        white-space: nowrap;
      }

      .left-title2 {
        font-weight: 500;
        font-size: 30px;
        color: #ffffff;
        white-space: nowrap;
        margin-top: 12px;
      }

      .left-title3 {
        font-weight: 400;
        font-size: 16px;
        color: #aaaaaa;
        white-space: nowrap;
        margin-top: 22px;
      }

      .left-title4 {
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
        margin-top: 16px;
        white-space: nowrap;
      }
    }

    .bottomBar-right {
      width: 430px;
      height: 100%;
      display: flex;
      justify-content: space-between;

      .right-menu1 {
        width: 64px;
        height: 100%;
        // background: red;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .menu1 {
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
        }

        .menu {
          font-weight: 400;
          font-size: 16px;
          color: #aaaaaa;
        }
      }

      .right-menu2 {
        width: 72px;
        height: 100%;

        // background: red;
        .menu1 {
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
        }

        .menu {
          font-weight: 400;
          font-size: 16px;
          color: #aaaaaa;
          margin-top: 16px;
        }
      }

      .right-menu3 {
        width: 72px;
        height: 100%;

        // background: red;
        .menu1 {
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
        }

        .menu {
          font-weight: 400;
          font-size: 16px;
          color: #aaaaaa;
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
